import styles from './_testimonialBlock.module.scss'
import { useEffect, useRef, useState } from 'react'
import { Tabs, usePanelState, useTabState } from '@bumaga/tabs'
import classnames from 'classnames'
import { TESTIMONIAL_QUERY } from '../../../gql/queries'
import { useQuery } from '@apollo/client'
import Image from 'next/legacy/image'
import isServer from '../../../utils/isServer'
import { Testimonial } from '../../../__generated__/graphql'

interface TestimonialProps {
  testimonial: Testimonial
}
const Tab = () => {
  if (isServer()) return <></>
  const { isActive, onClick } = useTabState()

  return (
    <button
      className={classnames(styles.testimonialsButton, {
        [styles.testimonialsButtonActive]: isActive
      })}
      onClick={onClick}
    ></button>
  )
}

const usePrevious = (value) => {
  const ref = useRef()
  useEffect(() => {
    ref.current = value
  })

  return ref.current
}

const Panel = ({ tabState, children }) => {
  if (isServer()) return <></>
  const isActive = usePanelState()
  const isPrevActive = usePrevious(isActive)
  const prevTabStateData = usePrevious(tabState)
  const prevTabState = prevTabStateData ? prevTabStateData : 0
  let panelIn = styles.testimonialsLeftIn
  let panelOut = styles.testimonialsRightOut

  if (tabState === 0 || prevTabState < tabState) {
    panelIn = styles.testimonialsRightIn
    panelOut = styles.testimonialsLeftOut
  }

  return isActive ? (
    <div className={panelIn}>{children}</div>
  ) : isPrevActive ? (
    <div className={panelOut}>{children}</div>
  ) : null
}

const TestimonialsBlock: React.FC = () => {
  const { data } = useQuery(TESTIMONIAL_QUERY)
  const initialTabState = 0
  const [tabState, setTabState] = useState(initialTabState)

  useEffect(() => {
    const interval = setInterval(() => {
      if (tabState === data?.testimonials.length - 1) {
        setTabState(initialTabState)
      } else {
        setTabState((prevTabState) => prevTabState + 1)
      }
    }, 5000)
    return () => clearInterval(interval)
  }, [tabState])

  const Testimonial: React.FC<TestimonialProps> = ({ testimonial }) => {
    const { author, image, organization, text } = testimonial

    return (
      <div className={styles.testimonialsMain}>
        <div className={styles.testimonialsImage}>
          <Image alt={author} src={image} width={125} height={125} />
        </div>
        <p className={styles.testimonialsText}>&quot;{text}&quot;</p>
        <p className={styles.testimonialsSign}>
          <span className={styles.testimonialsSignAuthor}>{author}</span>
          <span className={styles.testimonialsOrg}>{organization}</span>
        </p>
        <div className={styles.testimonialsRectangle}></div>
      </div>
    )
  }
  return (
    <section className={styles.testimonials}>
      <Tabs state={[tabState, setTabState]}>
        <div className={styles.testimonialsPanels}>
          {data?.testimonials.map((testimonial, index) => (
            <Panel key={index} tabState={tabState}>
              <Testimonial testimonial={testimonial} />
            </Panel>
          ))}
        </div>
        <div className={styles.testimonialsTabs}>
          {data?.testimonials.map((_, index) => <Tab key={index}></Tab>)}
        </div>
      </Tabs>
    </section>
  )
}

export default TestimonialsBlock
